
import { isUndefined } from "../lib/validation";

// we often sort a list of object by a key name
// This util function generates a function that passes into .sort
export const getSortFuncOnObjKey = (key, asc=true) => {
    return (a, b) => {
        if (isUndefined(a[key])) return asc ? -1 : 1;
        if (isUndefined(b[key])) return asc ? 1 : -1;
        if (a[key] === b[key]) return 0;
        if (a[key] > b[key]) return asc ? 1 : -1;
        if (a[key] < b[key]) return asc ? -1 : 1;
    };
}

export const sortAsc = (a, b) => {
    if(a < b) { return -1; }
    if(a > b) { return 1; }
    return 0;
}

export const sortDesc = (a, b) => {
    if(a > b) { return -1; }
    if(a < b) { return 1; }
    return 0;
}